var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "datepicker-trigger" },
    [
      _c(
        "div",
        { staticClass: "title-wrapper lgrid-noGutter-noWrap-spaceBetween" },
        [
          _c("div", [
            _c("button", { staticClass: "title", on: { click: _vm.close } }, [
              _c("span", { domProps: { innerHTML: _vm._s(_vm.placeholder) } }),
            ]),
          ]),
          _vm._t("header"),
        ],
        2
      ),
      _c(
        "v-date-picker",
        _vm._b(
          {
            ref: "datePicker",
            attrs: {
              locale: _vm.lang,
              "is-inline": "",
              disablePageSwipe: true,
              "is-expanded": true,
              mode: _vm.mode,
              columns: _vm.$screens({ default: 1, md: 2 }),
              rows: _vm.$screens({ default: 12, md: 1 }),
            },
            on: { dayclick: _vm.dayClick },
            model: {
              value: _vm.date,
              callback: function ($$v) {
                _vm.date = $$v
              },
              expression: "date",
            },
          },
          "v-date-picker",
          _vm.options,
          false
        )
      ),
      _vm._t("default"),
      _c("div", { staticClass: "action-buttons" }, [
        _c("button", { staticClass: "btn", on: { click: _vm.resetDisplay } }, [
          _vm._v(
            "\n      " +
              _vm._s(_vm.t.calendar.cancel || "Réinitialiser") +
              "\n    "
          ),
        ]),
        _c("button", { staticClass: "btn colored", on: { click: _vm.apply } }, [
          _vm._v(
            "\n      " + _vm._s(_vm.t.calendar.apply || "Appliquer") + "\n    "
          ),
        ]),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }